import { render } from "./restartRecordList.vue?vue&type=template&id=80a0ae08&scoped=true"
import script from "./restartRecordList.vue?vue&type=script&lang=js"
export * from "./restartRecordList.vue?vue&type=script&lang=js"

import "./restartRecordList.vue?vue&type=style&index=0&id=80a0ae08&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-80a0ae08"

export default script